import React from "react";
import { Box } from "@mui/material";
import HeroSection from "./HeroSection";
import CompanyListSection from "./CompanyListSection";
import CompanyMapSection from "./CompanyMapSection";
import MessagesSection from "./MessagesSection";
import PaymentsSection from "./PaymentsSection";
import SubscribeSection from "../HomeScreen/SubscribeSection";

const AccountExecutiveScreen = () => {
    return (
        <>
            <Box>
                <HeroSection />
            </Box>
            <Box>
                <CompanyListSection />
            </Box>
            <Box>
                <CompanyMapSection />
            </Box>
            <Box>
                <MessagesSection />
            </Box>
            <Box>
                <PaymentsSection />
            </Box>
            {/* <Box>
                <SubscribeSection />
            </Box> */}
        </>
    );
};

export default AccountExecutiveScreen;
